import type { IWeekdaysPickerFields } from "./WeekdaysPicker";
import { WeekdaysPicker } from "./WeekdaysPicker";
import type { IRecurrencePickerFields } from "./RecurrencePicker";
import { RecurrencePicker } from "./RecurrencePicker";
import type { ITimeSlotsPickerFields } from "./TimeSlotsPicker";
import { TimeSlotsPicker } from "./TimeSlotsPicker";
import type { IDateInputFields } from "./DateInput";
import { DateInput } from "./DateInput";
import {
  FrequencyPicker,
  type IFrequencyPickerFields,
} from "./FrequencyPicker";
import {
  CustomRecurringInterval,
  type ICustomRecurringIntervalFields,
} from "./CustomRecurringInput";
import { useSchedulingReset } from "./useSchedulingReset";

export type ISchedulingFields = IFrequencyPickerFields &
  IRecurrencePickerFields &
  IWeekdaysPickerFields &
  ICustomRecurringIntervalFields &
  IDateInputFields &
  ITimeSlotsPickerFields;

export const Scheduling = () => {
  const { isRecurring, isRecurringOnWeekdays, isCustomRecurring } =
    useSchedulingReset();

  return (
    <>
      <FrequencyPicker />
      {isRecurring ? (
        <>
          <RecurrencePicker />
          {isRecurringOnWeekdays ? <WeekdaysPicker /> : null}
          {isCustomRecurring ? <CustomRecurringInterval /> : null}
        </>
      ) : null}
      <DateInput hasEndDate={isRecurring} />
      <TimeSlotsPicker isRecurring={isRecurring} />
    </>
  );
};
